import { render, staticRenderFns } from "./practice-center.vue?vue&type=template&id=88a09948&scoped=true"
import script from "./practice-center.vue?vue&type=script&lang=js"
export * from "./practice-center.vue?vue&type=script&lang=js"
import style0 from "./practice-center.vue?vue&type=style&index=0&id=88a09948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a09948",
  null
  
)

export default component.exports